/* ==========================================================================
   Kuba Auri — comportamento das seções "Auri · …"
   Vanilla JS, sem dependências. Idempotente: pode rodar várias vezes
   (o editor de temas recarrega seções) sem duplicar listeners.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__auriLoaded) { window.__auriInit && window.__auriInit(); return; }
  window.__auriLoaded = true;
  document.documentElement.classList.add('auri-js');

  var io = null;
  function reveal() {
    var els = document.querySelectorAll('.auri-rv:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* --- scroll horizontal (fade + seta no mobile) --- */
  function horizontalScroll() {
    document.querySelectorAll('[data-auri-hs]').forEach(function (w) {
      var sc = w.firstElementChild;
      if (!sc || sc.__auriHs) return;
      sc.__auriHs = true;
      var upd = function () {
        var more = sc.scrollWidth - sc.clientWidth - sc.scrollLeft > 12;
        w.setAttribute('data-hs-end', more ? '0' : '1');
      };
      sc.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* --- galeria da seção de produto --- */
  function gallery() {
    document.querySelectorAll('[data-auri-gallery]').forEach(function (g) {
      if (g.__auri) return;
      g.__auri = true;
      var track = g.querySelector('[data-auri-track]');
      var slides = track ? track.children.length : 0;
      var dots = g.querySelectorAll('[data-auri-dot]');
      var i = 0;
      var prev = g.querySelector('[data-auri-prev]'), next = g.querySelector('[data-auri-next]');
      function go(n) {
        if (!slides) return;
        i = Math.max(0, Math.min(slides - 1, n));           // sem "dar a volta": setas desativam nas pontas (design)
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides - 1;
      }
      prev && prev.addEventListener('click', function () { go(i - 1); });
      next && next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.auriDot, 10)); }); });
      // swipe
      var x0 = null;
      g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      }, { passive: true });
      go(0);
    });
  }

  /* --- variantes na seção de produto (atualiza preço, parcela, id e botão) --- */
  function variants() {
    document.querySelectorAll('[data-auri-variant]').forEach(function (r) {
      if (r.__auri) return;
      r.__auri = true;
      r.addEventListener('change', function () {
        var sec = r.closest('.auri-pdp');
        if (!sec) return;
        var now = sec.querySelector('[data-auri-price-now]');
        var was = sec.querySelector('[data-auri-price-was]');
        var inst = sec.querySelector('[data-auri-installments]');
        var idInput = sec.querySelector('[data-auri-variant-id]');
        var buy = sec.querySelector('[data-auri-buy]');
        var buyLabel = sec.querySelector('[data-auri-buy-label]');
        var avail = r.dataset.available === 'true';
        if (now) now.textContent = r.dataset.price;
        if (was) { if (r.dataset.compare) { was.textContent = r.dataset.compare; was.hidden = false; } else { was.hidden = true; } }
        if (inst) inst.textContent = 'ou ' + r.dataset.installment + (inst.dataset.suffix ? ' ' + inst.dataset.suffix : '');
        if (idInput) idInput.value = r.value;
        if (buy) { buy.disabled = !avail; }
        if (buyLabel) buyLabel.textContent = avail ? buyLabel.dataset.label : buyLabel.dataset.soldout;
      });
    });
  }

  /* --- checkout direto pela Yampi ---
     Forms .auri-form--yampi: adiciona ao carrinho (/cart/add.js) e chama yampiClick(),
     a mesma função que o botão "Finalizar compra" do cart drawer do tema usa.
     Sem yampiClick() na página (snippet da Yampi ausente), cai em /cart — que também redireciona pra Yampi.
     Nunca usa o permalink /cart/VARIANT:1 (esse pula a Yampi e cai no checkout do Shopify). */
  function yampiForms() {
    document.querySelectorAll('form.auri-form--yampi').forEach(function (f) {
      if (f.__auri) return;
      f.__auri = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = f.querySelector('[data-auri-yampi-btn]');
        var label = f.querySelector('[data-auri-yampi-label]');
        var err = f.querySelector('.auri-form__error');
        var idInput = f.querySelector('input[name="id"]');
        var qtyInput = f.querySelector('input[name="quantity"]');
        var id = idInput ? idInput.value : '';
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var original = label ? label.textContent : '';
        var action = (f.getAttribute('action') || '/cart/add').replace(/\.js$/, '') + '.js';
        if (!id) return;
        // combo "comprados juntos" (seção de produto): extras marcados entram junto com o produto
        var items = [{ id: id, quantity: qty }];
        f.querySelectorAll('input[name="items[][id]"]:not(:disabled)').forEach(function (h) {
          var v = parseInt(h.value, 10);
          if (v) items.push({ id: v, quantity: 1 });
        });
        if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
        if (label) label.textContent = 'Aguarde…';
        if (err) err.hidden = true;
        fetch(action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(items.length > 1 ? { items: items } : { id: id, quantity: qty })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Não foi possível adicionar ao carrinho.');
            if (typeof window.yampiClick === 'function') { window.yampiClick(); }
            else { window.location.href = '/cart'; }
          })
          .catch(function (ex) {
            if (btn) { btn.disabled = false; btn.style.opacity = ''; }
            if (label) label.textContent = original;
            if (err) {
              var m = err.querySelector('.hdt-error-message') || err;
              m.textContent = ex && ex.message ? ex.message : 'Não foi possível adicionar ao carrinho.';
              err.hidden = false;
            }
          });
      }, true);
    });
  }

  /* --- barras da pesquisa (seção margem) --- */
  function fmt(v) { return v.toFixed(1).replace('.', ',') + '%'; }
  function margem() {
    document.querySelectorAll('[data-auri-margem]').forEach(function (sec) {
      if (sec.__auri) return;
      sec.__auri = true;
      var chips = sec.querySelectorAll('[data-auri-cohort]');
      var note = sec.querySelector('[data-auri-cohort-note]');
      function apply(chip) {
        chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        var grave = parseFloat(chip.dataset.grave) || 0;
        var agudo = parseFloat(chip.dataset.agudo) || 0;
        if (note) note.textContent = chip.dataset.note || '';
        sec.querySelectorAll('[data-auri-bar]').forEach(function (bar) {
          var kind = bar.dataset.auriBar;                       // grave | agudo
          var win = bar.dataset.win;                            // left | right (lado vencedor)
          var a = bar.querySelector('[data-seg="a"]'), b = bar.querySelector('[data-seg="b"]');
          var pct = kind === 'grave' ? grave : agudo;           // % da preferência majoritária
          var left = win === 'left' ? pct : 100 - pct;
          a.style.width = left + '%'; b.style.width = (100 - left) + '%';
          a.querySelector('[data-val]').textContent = fmt(left);
          b.querySelector('[data-val]').textContent = fmt(100 - left);
        });
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { apply(c); }); });
      if (chips.length) apply(chips[0]);
    });
  }

  /* --- barra fixa --- */
  function sticky() {
    document.querySelectorAll('[data-auri-sticky]').forEach(function (bar) {
      if (bar.__auri) return;
      bar.__auri = true;
      bar.hidden = false;
      var after = parseFloat(bar.dataset.after) || 1.6;
      var upd = function () {
        bar.classList.toggle('is-on', (window.scrollY || 0) > window.innerHeight * after);
      };
      window.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* --- modal de vídeo (YouTube) --- */
  function closeVideo() {
    var m = document.querySelector('.auri-video');
    if (m) m.remove();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') closeVideo(); }
  function openVideo(id, title) {
    closeVideo();
    var m = document.createElement('div');
    m.className = 'auri auri-video';
    var inner = id
      ? '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="' + (title || '').replace(/"/g, '&quot;') + '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>'
      : '<div class="auri-video__empty">Adicione o ID do vídeo do YouTube em Configurações do tema → Auri (ou na seção Autoria).</div>';
    m.innerHTML = '<div class="auri-video__box"><button type="button" class="auri-video__close" aria-label="Fechar">×</button>' + inner + '</div>';
    m.addEventListener('click', function (e) { if (e.target === m || e.target.classList.contains('auri-video__close')) closeVideo(); });
    document.body.appendChild(m);
    document.addEventListener('keydown', onKey);
  }
  function video() {
    document.querySelectorAll('[data-auri-video-open]').forEach(function (b) {
      if (b.__auri) return;
      b.__auri = true;
      b.addEventListener('click', function () { openVideo(b.dataset.auriVideoOpen, b.dataset.auriVideoTitle); });
    });
  }

  /* --- âncoras suaves (#comprar etc.) --- */
  function anchors() {
    document.querySelectorAll('.auri a[href^="#"]').forEach(function (a) {
      if (a.__auri) return;
      a.__auri = true;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var t = id && document.getElementById(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function init() {
    reveal(); horizontalScroll(); gallery(); variants(); yampiForms(); margem(); sticky(); video(); anchors();
    setTimeout(reveal, 900);
    setTimeout(horizontalScroll, 900);
  }
  window.__auriInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // editor de temas: seções são re-renderizadas
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('shopify:section:select', function () {
    document.querySelectorAll('.auri-rv').forEach(function (e) { e.classList.add('in'); });
  });
  document.addEventListener('shopify:block:select', function () {
    document.querySelectorAll('.auri-rv').forEach(function (e) { e.classList.add('in'); });
  });
})();
